// Unpublished Work © 2024 Deere & Company. All Worldwide Rights Reserved.
// THIS MATERIAL IS THE PROPERTY OF DEERE & COMPANY.
// ALL USE, ALTERATIONS AND/OR REPRODUCTION NOT SPECIFICALLY
// AUTHORIZED BY DEERE & COMPANY IS PROHIBITED.

export const ONLINK_BLUE = '#2677bb';
export const ONLINK_WHITE = '#fff';
export const JD_GREEN_THEME = '#367c2b';
export const SECONDARY = '#F1F0F0';
export const TEXT_PRIMARY = '#1B1C1B';
export const INFO = '#BFD5FF';
